import { render, staticRenderFns } from "./SectionSchedule.vue?vue&type=template&id=1637b3eb&scoped=true&"
import script from "./SectionSchedule.vue?vue&type=script&lang=js&"
export * from "./SectionSchedule.vue?vue&type=script&lang=js&"
import style0 from "./SectionSchedule.vue?vue&type=style&index=0&id=1637b3eb&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1637b3eb",
  null
  
)

export default component.exports